// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FolderOpenFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from folder-open-filled.svg
 */
export default function FolderOpenFilledIcon(props: FolderOpenFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FolderOpenFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M6.895 1.948A1.5 1.5 0 0 0 5.5 1h-3l-.144.007A1.5 1.5 0 0 0 1 2.5L.999 4.133a1.5 1.5 0 0 0-.873 1.533l.877 7.89.006.135C1.08 14.405 1.72 15 2.5 15h11l.145-.007A1.5 1.5 0 0 0 15 13.5l.874-7.834.006-.083.003-.083A1.5 1.5 0 0 0 15 4.133L15 3.5l-.007-.144A1.5 1.5 0 0 0 13.5 2H6.913zM2.5 2h3l.09.008A.5.5 0 0 1 6 2.5l.008.09A.5.5 0 0 0 6.5 3h7l.09.008A.5.5 0 0 1 14 3.5V4H2V2.5l.008-.09A.5.5 0 0 1 2.5 2"
        />
      </g>
    </svg>
  );
}
